<div
  class="scroll vi-primary vi-hue-1 print-content no-print-flexbox truespeed-content internal"
  #pdfPage
  *ngIf="!loading"
>
  <div layout="column" class="page">
    <div class="page-break"></div>

    <div class="report-header">
      <img src="{{ logoUrl }}" class="truespeed-logo" />
      <h2 class="truespeed-title">{{ reportTitle }}</h2>
    </div>

    <hr />
    <div class="margin-10-left">
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style">
          <div class="header-class">Test Name</div>
          <div class="value-font">
            {{ requestInfo?.testName }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Start Date</div>
          <div class="value-font">{{ startDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">End Date</div>
          <div class="value-font">{{ stopDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">Duration</div>
          <div class="value-font">{{ duration }}</div>
        </div>
        <div class="header-style" *ngIf="overallConfiguration">
          <div class="header-class">Test Points</div>
          <div class="value-font">
            {{ overallConfiguration.agent.primary.id }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            overallConfiguration &&
            overallConfiguration.agent.secondary &&
            overallConfiguration.agent.secondary.length > 0
          "
        >
          <div class="header-class"></div>
          <div
            class="value-font"
            *ngIf="
              overallConfiguration &&
              overallConfiguration.agent.secondary &&
              overallConfiguration.agent.secondary.length > 0
            "
          >
            {{ overallConfiguration.agent.secondary[0].id }}
          </div>
        </div>
      </div>
      <div
        *ngIf="
          requestInfo?.customerInfo?.name ||
          requestInfo?.customerInfo?.contact ||
          requestInfo?.customerInfo?.phone ||
          requestInfo?.customerInfo?.email
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Customer</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
              <div class="sec-header">Contact</div>
              <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
              <div class="sec-header">Email</div>
              <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
              <div class="sec-header">Phone</div>
              <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
        requestInfo &&
          (requestInfo?.['techInfo']?.name ||
          requestInfo?.['techInfo']?.id)
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container">
            <div
              class="details-sec"
              *ngIf="
            requestInfo && requestInfo?.['techInfo']?.name
            "
            >
              <div class="sec-header">Name</div>
              <div class="sec-value">
                {{ requestInfo?.['techInfo']?.name }}
              </div>
            </div>
            <div
              class="details-sec"
              *ngIf="
              overallConfiguration &&
              requestInfo?.['techInfo']?.id
            "
            >
              <div class="sec-header">ID</div>
              <div class="sec-value">
                {{ requestInfo?.['techInfo']?.id }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 30px" *ngIf="requestInfo && requestInfo?.comments">
        <div class="header-style">
          <div class="header-class">Comments</div>
          <div class="value-font">
            {{ requestInfo.comments }}
          </div>
        </div>
      </div>
      <div style="margin-top: 30px">
        <div class="header-style">
          <div class="header-class">Summary</div>
          <div class="pass-color" *ngIf="overallResult === 'Pass'">TEST PASSED</div>
          <div class="fail-color" *ngIf="overallResult === 'Fail'">
            TEST FAILED
            <div class="fail-color-3" *ngIf="errorMessage">{{ errorMessage }}</div>
          </div>

          <div class="unknown-color" *ngIf="overallResult === 'Inconclusive'">
            TEST INCONCLUSIVE
          </div>
          <div class="unknown-color" *ngIf="overallResult === 'Unknown'">
            TEST {{ controllerStatus }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div layout="column" class="page" *ngIf="spAngReport">
    <div class="page-break"></div>
    <div class="header-font-1">
      <div class="alignment-font">
        <img class="icon" [attr.src]="'images/SPTIcon.svg'" />
        <span class="margin-10-left">BERT Test Results</span>
      </div>
      <button
        mat-button
        *ngIf="!resultsNotAvailable && spAngReport && !trendingInProgress && !trendingComplete"
        class="btn btn-blue"
        style="margin-right: 40px"
        (click)="trendCharts()"
      >
        Show Trend Charts
      </button>

      <div
        class="getting-trending-container vi-primary-font-color no-print"
        *ngIf="trendingInProgress"
      >
        <i class="fa fa-circle-o-notch fa-spin"> </i>
        <div class="trending-msg">{{ trendingMsg }}</div>
        <div class="trending-progress-bar">
          <md-progress-linear
            md-mode="determinate"
            class="trending-progress"
            value="{{ trendingPercent }}"
          ></md-progress-linear>
        </div>
      </div>
    </div>
    <hr />
    <ng-container *ngIf="!showRtdOptions">
      <ng-container *ngFor="let row of sortSpAngReport">
        <hr
          class="line-color"
          *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'"
        />
        <div
          class="stream-font"
          *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'"
        >
          {{ row['stream-name'] }}
        </div>
        <div class="verdict-display">
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-1">PASSED</div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-1">FAILED</div>
          <!-- <div style="font-size: 14px; font-weight: bold; margin-left: 20px; margin-right: 1px;" *ngIf="row['originator'] === 'engine-a'">
          {{ row['stream-name'] }}
        </div> -->
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-2">
            {{ row['verdict-reason'] }}
          </div>
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-2">
            {{ row['verdict-reason'] }}
          </div>
        </div>
        <div class="field-style">
          <div class="width-font">
            <div *ngIf="row['frame-size-average']" class="alignment-font">
              <div class="bold-font">Frame</div>
              <div>: {{ row['frame-size-average'] }}</div>
            </div>
            <div *ngIf="row['target-ir']" class="alignment-font">
              <div class="bold-font">Target IR</div>
              <div>: {{ row['target-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ir']" class="alignment-font">
              <div class="bold-font">Tx IR</div>
              <div>: {{ row['transmitted-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ulr']" class="alignment-font">
              <div class="bold-font">Tx ULR</div>
              <div>:{{ row['transmitted-ulr'] }} Mbps</div>
            </div>
            <div *ngIf="row['network-ulr']" class="alignment-font">
              <div class="bold-font">Network ULR</div>
              <div>: {{ row['network-ulr'] }} Mbps</div>
            </div>
          </div>
          <table class="sp-table" style="width: 80%">
            <tr>
              <th *ngIf="row['ir-min'] || row['ir-avg'] || row['ir-max']">IR</th>
              <th
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                Loss
              </th>
              <ng-container>
                <th
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>

              <th
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                Counts
              </th>
              <th
                class="th-background-color"
                [ngStyle]="
                  row['ber-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                BER
              </th>
            </tr>
            <tr>
              <td *ngIf="row['ir-avg'] || row['ir-min'] || row['ir-max']" class="header-top-color">
                <div class="bold-font" *ngIf="row['transmitted-ir']">
                  Tx: {{ row['transmitted-ir'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font" *ngIf="row['ir-avg']">
                  Rx Avg: {{ row['ir-avg'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['ir-min']">Rx Min: {{ row['ir-min'] }} Mbps</div>
                  <div *ngIf="row['ir-max']">Rx Max: {{ row['ir-max'] }} Mbps</div>
                </div>
              </td>
              <td
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div
                  class="bold-font"
                  *ngIf="
                    row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined'
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }} <span class="normal-font">%</span>
                </div>

                <div class="margin-10">
                  <div *ngIf="row['peak-frame-loss-ratio']">
                    Peak: {{ row['peak-frame-loss-ratio'] }} %
                  </div>
                  <div *ngIf="row['frame-loss-sla']">SLA: {{ row['frame-loss-sla'] }} %</div>
                </div>
              </td>
              <ng-container *ngIf="versionValue !== 'v1'">
                <td
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }}
                      <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }}
                      <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }}
                      <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container *ngIf="versionValue === 'v1'">
                <td
                  *ngIf="row['rtd-avg'] || row['rtd-min'] || row['rtd-max'] || row['rtd-sla']"
                  [ngStyle]="
                    row['rtd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div class="bold-font" *ngIf="row['rtd-avg']">
                    Avg: {{ row['rtd-avg'] }}
                    <span *ngIf="row['rtd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['rtd-min']">
                      Min: {{ row['rtd-min'] }}
                      <span *ngIf="row['rtd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['rtd-max']">
                      Max: {{ row['rtd-max'] }}
                      <span *ngIf="row['rtd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['rtd-sla']">
                      SLA: {{ row['rtd-sla'] }}
                      <span *ngIf="row['rtd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <td
                *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                [ngStyle]="
                  row['fdv-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div
                  class="bold-font"
                  *ngIf="row['fdv-avg']"
                  [ngClass]="{
                    'kpi-good': row['fdv-verdict'] === 'pass',
                    'kpi-bad': row['fdv-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ row['fdv-avg'] }}
                  <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                </div>
                <div class="margin-10" *ngIf="row['fdv-max']">
                  <div>
                    Max: {{ row['fdv-max'] }}
                    <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                  </div>
                  <div *ngIf="row['fdv-sla']">
                    SLA: {{ row['fdv-sla'] }}
                    <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                  </div>
                </div>
              </td>
              <td
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                <div *ngIf="row['tx-frame-count']">Tx: {{ row['tx-frame-count'] }}</div>
                <div *ngIf="row['rx-frame-count']">Rx: {{ row['rx-frame-count'] }}</div>
                <div *ngIf="row['frame-loss-count']">Lost: {{ row['frame-loss-count'] }}</div>
                <div *ngIf="row['oos-count']">OOS: {{ row['oos-count'] }}</div>
                <div *ngIf="row['pattern-loss-count']">
                  Pattern Loss: {{ row['pattern-loss-count'] }}
                </div>
              </td>
              <td
                class="th-background-color"
                [ngStyle]="
                  row['ber-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div>Bit Errors: {{ row['bit-error-count'] }}</div>
                <div>Bit Error Rate: {{ row['bit-error-rate'] }}</div>
                <div *ngIf="row['ber-sla']">SLA: {{ row['ber-sla'] }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="trendChartsData" class="sct-metric-container">
          <div *ngFor="let series of chartSeriesConfig" class="sct-metrics">
            <ng-container *ngFor="let stream of performanceData" class="field-style">
              <div *ngIf="row['stream-name'] === stream.name" class="sct-metric-section">
                <div *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'">
                  <nrwl-stream-metrics-chart
                    [seriesOptions]="series"
                    [chartData]="stream.engineAData.dataSource"
                    [stepTime]="durationForStream"
                    [streamConfig]="stream.streamConfig"
                    [showCurrentValue]="false"
                  ></nrwl-stream-metrics-chart>
                </div>
                <div *ngIf="row['originator'] === 'engine-b' || row['originator'] === 'ENGINE_B'">
                  <nrwl-stream-metrics-chart
                    [seriesOptions]="series"
                    [chartData]="stream.engineBData.dataSource"
                    [stepTime]="durationForStream"
                    [streamConfig]="stream.streamConfig"
                    [showCurrentValue]="false"
                  ></nrwl-stream-metrics-chart>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div layout="column" class="page">
    <div class="page-break"></div>
    <div class="header-font-2">
      <i class="material-icons icon">settings</i>
      <span class="margin-10-left">Test Configuration</span>
    </div>
    <hr />
    <div class="test-margin">
      <div class="test-font">Test Setup</div>
      <table
        style="width: 70%; border-left: unset; border-right: unset; font-size: 14px"
        class="test-setup-table"
      >
        <tr>
          <td class="test-color">Layer to Test</td>
          <td>{{ layer }}</td>
        </tr>
        <tr *ngIf="layer === 'L3'">
          <td class="test-color">IP Address Type</td>
          <td>{{ ipAddressType }}</td>
        </tr>

        <!-- Service Performance Section -->
        <ng-container *ngIf="spAngReport">
          <tr>
            <td class="test-color">BERT Test Duration</td>
            <td>{{ duration }}</td>
          </tr>
        </ng-container>
        <tr>
          <td class="test-color">Bert Pattern</td>
          <td>{{ bertPattern }}</td>
        </tr>
        <tr>
          <td class="test-color">Swap Mac Address<Address></Address></td>
          <td>{{ swapMacAddress }}</td>
        </tr>
        <tr *ngIf="showSvlan">
          <td class="test-color">S-VLAN</td>
          <td>
            {{ testConfigDisplay.sVlan.value }}
          </td>
        </tr>
        <tr *ngIf="showSetherType">
          <td class="test-color">S-Ether Type</td>
          <td>
            {{ testConfigDisplay.sEtherType.value }}
          </td>
        </tr>
      </table>
    </div>

    <div class="test-margin">
      <div class="test-font">Endpoints</div>
      <div style="width: 70%">
        <table
          style="border-left: unset; border-right: unset; font-size: 14px; width: 100%"
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">
              <span *ngIf="!bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']"
                >Originator</span
              ><span *ngIf="bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']"
                >Test Point A</span
              >
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>{{ overallConfiguration.agent.primary.id }}</td>
          </tr>
          <tr *ngIf="testConfigDisplay.tpaVersion">
            <td class="test-color">Version</td>
            <td>{{ testConfigDisplay.tpaVersion }}</td>
          </tr>
          <tr>
            <td class="test-color">Agent Type</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-a-info']['engine-type'] }}
            </td>
          </tr>
          <tr
            *ngIf="bertTestConfig['viavi-solutions-bert:bert']['bert-parameters']['tx-interface']"
          >
            <td class="test-color">MAC Address</td>
            <td
              *ngIf="
                bertTestConfig['viavi-solutions-bert:bert']['bert-parameters']['tx-interface'] ===
                'equipment'
              "
            >
              {{ equipmentMacAddress }}
            </td>
            <td
              *ngIf="
                bertTestConfig['viavi-solutions-bert:bert']['bert-parameters']['tx-interface'] ===
                'network'
              "
            >
              {{ networkMacAddress }}
            </td>
          </tr>
          <tr
            *ngIf="bertTestConfig['viavi-solutions-bert:bert']['bert-parameters']['tx-interface']"
          >
            <td class="test-color">Transmit Interface</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['bert-parameters']['tx-interface'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3' && defineAddressUsing">
            <td class="test-color">Define address using</td>
            <td>
              {{ defineAddressUsing }}
            </td>
          </tr>
          <tr *ngIf="originMngmtIpAddress && !isJmep">
            <td class="test-color">Management Address</td>
            <td>
              {{ originMngmtIpAddress }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Management Port</td>
            <td>{{ bertTestConfig['viavi-solutions-bert:bert']['engine-a-info'].port }}</td>
          </tr>

          <tr
            *ngIf="
              layerToTest === '3' &&
              bertTestConfig['viavi-solutions-bert:bert']['engine-a-info']['test-ip']
            "
          >
            <td class="test-color">Test Address</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-a-info']['test-ip'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Subnet Mask</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-a-info']['test-subnet-mask'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Gateway</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-a-info']['test-gateway'] }}
            </td>
          </tr>
        </table>
        <table
          *ngIf="bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']"
          style="
            border-left: unset;
            border-right: unset;
            margin-top: 20px;
            font-size: 14px;
            width: 100%;
          "
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">Test Point B</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>{{ overallConfiguration.agent.secondary[0].id }}</td>
          </tr>
          <tr *ngIf="testConfigDisplay.tpbVersion">
            <td class="test-color">Version</td>
            <td>{{ testConfigDisplay.tpbVersion }}</td>
          </tr>
          <tr>
            <td class="test-color">Agent Type</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']['engine-type'] }}
            </td>
          </tr>
          <tr *ngIf="destinationMngmtIpAddress && !isJmep">
            <td class="test-color">Management Address</td>
            <td>
              {{ destinationMngmtIpAddress }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Management Port</td>
            <td>{{ bertTestConfig['viavi-solutions-bert:bert']['engine-b-info'].port }}</td>
          </tr>

          <tr
            *ngIf="
              layerToTest === '3' &&
              bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']['test-ip']
            "
          >
            <td class="test-color">Test Address</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']['test-ip'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Subnet Mask</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']['test-subnet-mask'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Gateway</td>
            <td>
              {{ bertTestConfig['viavi-solutions-bert:bert']['engine-b-info']['test-gateway'] }}
            </td>
          </tr>
        </table>
        <table
          *ngIf="
            !bertTestConfig['viavi-solutions-bert:bert']['engine-b-info'] &&
            (testMode === 'loopback' || testMode === 'Loopback')
          "
          style="
            border-left: unset;
            border-right: unset;
            font-size: 14px;
            margin-top: 20px;
            width: 100%;
          "
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">Destination</td>
            <td></td>
          </tr>
          <ng-container *ngFor="let attr of testConfigDisplay.destination">
            <tr>
              <td class="test-color">{{ attr.name }}</td>
              <td>{{ attr.value }}</td>
            </tr>
          </ng-container>
          <tr>
            <td class="test-color">Loopup Device</td>
            <td>
              {{ getLoopUpValue() }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div layout="column" class="page">
    <div class="page-break"></div>
    <div style="font-size: 14px; font-weight: bold; display: flex; align-items: center">
      <i class="material-icons icon">settings</i>
      <span class="margin-10-left">Test Configuration</span>
    </div>
    <hr />
    <div class="test-margin" *ngFor="let stream of testConfigDisplay.streams; let i = index">
      <div class="test-font">Streams</div>
      <div style="width: 70%">
        <table
          style="width: 100%; border-left: unset; border-right: unset; font-size: 14px"
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">{{ stream.name }}</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>{{ stream.name }}</td>
          </tr>
          <tr *ngIf="layerToTest === '3' && stream['toSDiffServValue']">
            <td class="test-color">DSCP</td>
            <td>{{ stream['toSDiffServValue'] }}</td>
          </tr>

          <tr>
            <td class="test-color">ULR</td>
            <td>{{ stream['ulr-from-engine-a'] }} Mbps</td>
          </tr>
          <tr>
            <td class="test-color">FD</td>
            <td>{{ stream['frame-delay-threshold'] }} ms</td>
          </tr>
          <tr *ngIf="stream['latency-FDV-maximum']">
            <td class="test-color">FDV</td>
            <td>{{ stream['latency-FDV-maximum'] }} ms</td>
          </tr>

          <tr>
            <td class="test-color">Frame Loss</td>
            <td>{{ stream['frame-loss-ratio-threshold'] }}%</td>
          </tr>

          <tr>
            <td class="test-color">BER Threshold</td>
            <td>{{ stream['ber-threshold'] }}</td>
          </tr>

          <tr>
            <td class="test-color">Frame Size</td>
            <td>{{ stream['frame-length'] }}</td>
          </tr>

          <tr *ngIf="stream['filter-on-tos']">
            <td class="test-color">Verify DSCP/TOS</td>
            <td>{{ stream['filter-on-tos'] }}</td>
          </tr>
          <tr>
            <td class="test-color">Verify Priority</td>
            <td>{{ stream['filter-on-priority'] }}</td>
          </tr>
          <tr *ngIf="stream['fail-on-OOS']">
            <td class="test-color">Error on OOS frame</td>
            <td>{{ stream['fail-on-OOS'] }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div
    fxLayout="column"
    class="page"
    fxLayoutGap="16px"
    *ngIf="reportmessage && reportmessage?.length !== 0"
  >
    <div class="page-break"></div>

    <mat-toolbar class="diagnosis-head border">
      <div class="mat-toolbar-tools">
        <h2 class="mat-flex">Report Message</h2>
      </div>
    </mat-toolbar>

    <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row">
        <span>{{ reportmessage }}</span>
      </div>
    </mat-card>
  </div>
</div>
<div class="truespeed-content">
  <div class="loader-content" *ngIf="loading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Getting Reports</div>
    </div>
  </div>
</div>
